<div class="content__layout">
    <div class="list" [class.home-grid]="appearance === 'home'" [style]="Props?.styles" [attr.aria-busy]="isLoading">
        <ng-container *ngIf="!isLoading; else _loading">
            <ng-container *ngFor="let product of Products; trackBy: trackBy">
                <app-product [appearance]="appearance" [Props]="{
                    code: product.code,
                    isPublic: product.isPublic,
                    name: product.name,
                    imgUrl: product.imgUrl,
                    isExpired: product.isExpired,
                    description: product.description,
                    isNew: product.isNew
                }"></app-product>
            </ng-container>
        </ng-container>
    </div>
    <ng-template #_loading>
        <ng-container *ngFor="let item of [0,1,2,3,4,5,6]">
            <app-product [appearance]="appearance"></app-product>
        </ng-container>
    </ng-template>
</div>
